"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LINK_COLUMN = void 0;
const LINK_COLUMN = exports.LINK_COLUMN = 'link-column';